import { AfterViewInit, Component, EventEmitter, Host, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { SharedService } from '@ems/shared';
import { SharedConstant } from '@ems/shared';
import {  FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { emtrConstant } from '../constants/emtrConstants';
import { RuleService } from '../services/rule-service/rule.service';
import {MessageService} from 'primeng/api'
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'tr-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html'
})
export class DeleteConfirmationModalComponent implements OnInit, AfterViewInit{

  sharedConstant = SharedConstant;
  emtrConstant = emtrConstant;
  globalOrSemiGlobalRuleNameDeleteForm: FormGroup;
  public title = 'Confirmation';
  deleteMsg: any;
  @Input() ruleData:any;
  @Input() globalSemiGlobalInformationMsg: string;
  @Input() globalSemiGlobalConfirmationMsg : string;
  @Input() validationButtonlabel : string;
  @Input() popupHeaderTitle: string;
  @Input() invalidErrorMessage!: BehaviorSubject<string>;
  @Output() globalOrSemiGlobalRuleDeleted = new EventEmitter<boolean | string>();
  ruleDeleted: any;
  invalidError : string;

  constructor(public sharedService: SharedService, public fb: UntypedFormBuilder, public ruleService: RuleService, public messageService: MessageService) { }

  ngOnInit(): void {
    this.globalOrSemiGlobalRuleNameDeleteForm = this.fb.group({
      globalOrSemiGlobalRuleNameValue: ['', [Validators.required, Validators.maxLength(100)]]
    });
  }

  ngAfterViewInit(): void {
    if (this.invalidErrorMessage) {
      this.invalidErrorMessage.subscribe(data => {
        this.invalidError = data;
      });
    }
  }

  public openModal(ruleData) {
    this.title = `${this.popupHeaderTitle} - ${ruleData.name}`;
    this.ruleData = ruleData;
    this.sharedService.openModal('delete-confirmation-modal');
    this.globalOrSemiGlobalRuleNameDeleteForm.reset();
  }

  deleteorModifyRule() {

    //delete Rule
    if (this.validationButtonlabel == emtrConstant.rulesConstant.rulesLanding.delete){
      // Check if this is a rule (has ruleType) or master group
      if (this.ruleData?.ruleType) {
        // Delete Rule
        this.ruleService.deleteRule(this.ruleData.id, this.globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim()).subscribe((data) => {
          this.deleteMsg = '<strong>' + this.ruleData.name + '</strong>' + ' - ' + this.ruleData.ruleType + '&nbsp;' + this.emtrConstant.rulesConstant.ruleGlobalConst.deleteSuccessMsg;
          this.ruleService.sendMessage(this.deleteMsg);
          this.globalOrSemiGlobalRuleDeleted.emit(true);
          this.sharedService.closeModal('delete-confirmation-modal');
        }, error => {
          const errorMessage = error?.error?.errorResponse?.errorMessage;
          this.invalidError = errorMessage;
          this.sharedService.clearErrorMessage();
        });
      } else {
        // Delete Master Group - emit the entered name for validation
        this.globalOrSemiGlobalRuleDeleted.emit(this.globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim());
      }
    }
    //Modify Rule for edit step2
    if (this.validationButtonlabel == this.sharedConstant.confirmationDialog.proceedBtn) {
      this.globalOrSemiGlobalRuleDeleted.emit(this.globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim());
    }

    // OBP Rule for copy and unassign 
    if (this.validationButtonlabel === this.emtrConstant.rulesConstant.ruleGlobalConst.copyAndUnassign) {
      if (this.ruleData.name === this.globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim()) {
        this.ruleService.copyAndUnassignRule(this.ruleData).subscribe({
          next: (data: any) => {
            this.deleteMsg = '<strong>' + this.ruleData.name + '</strong>' + ' ' + this.emtrConstant.rulesConstant.ruleGlobalConst.copyAndUnassignSuccessMsg;
            this.ruleService.sendMessage(this.deleteMsg);
            this.globalOrSemiGlobalRuleDeleted.emit(true);
            this.sharedService.closeModal('delete-confirmation-modal');
          },
          error: (error: any) => {
            const errorMessage = error?.error?.errorResponse?.errorMessage;
            this.invalidError = errorMessage;
            this.sharedService.clearErrorMessage();
          }
        });
      }
      else {
        this.invalidError = this.emtrConstant.rulesConstant.ruleMessages.invalidSemiGlobalRuleNameForCopyAndUnassignErrorMsg;
      }
    }

    //OBP rule for unassign
    if (this.validationButtonlabel === this.emtrConstant.rulesConstant.ruleGlobalConst.unassign) {
      if (this.ruleData.name === this.globalOrSemiGlobalRuleNameDeleteForm.get('globalOrSemiGlobalRuleNameValue').value?.trim()) {
        this.ruleService.unassignRule(this.ruleData).subscribe({
          next: (data: any) => {
            this.deleteMsg = '<strong>' + this.ruleData.name + '</strong>' + ' ' + this.emtrConstant.rulesConstant.ruleGlobalConst.unassignSuccessMsg;
            this.ruleService.sendMessage(this.deleteMsg);
            this.globalOrSemiGlobalRuleDeleted.emit(true);
            this.sharedService.closeModal('delete-confirmation-modal');
          },
          error: (error: any) => {
            const errorMessage = error?.error?.errorResponse?.errorMessage;
            this.invalidError = errorMessage;
            this.sharedService.clearErrorMessage();
          }
        });
      }
      else {
        this.invalidError = this.emtrConstant.rulesConstant.ruleMessages.invalidSemiGlobalRuleNameForUnassignErrorMsg;
      }
    }
    this.globalOrSemiGlobalRuleNameDeleteForm.reset();
  }

  /* Closes The Modal */
  public closeModal(): void {
    this.globalOrSemiGlobalRuleNameDeleteForm.reset();
    this.sharedService.clearErrorMessage();
    this.invalidError = '';
    if (this.invalidErrorMessage) {
      this.invalidErrorMessage.next('');
    }
  }
}
